import styled, { css } from 'styled-components';

export const Content = styled.div`
  max-width: 250px;
  width: 100%;
  //height: 100%;
`;

export const CalendarPlace = styled.div`
  position: absolute;
  ${(props) =>
    props.theme.ui === 'v2' &&
    css`
      z-index: 4000;
    `}
  /* Match the redux-form calendar: CP dark surfaces (with hex fallback for v1)
     so the Formik calendar is never white/old in dark mode. In v2 cp-global's
     global rules already handle both themes; this covers v1 dark too. */
  ${(props) =>
    props.theme.theme === 'dark' &&
    css`
      .rc-calendar,
      .rc-calendar-date-panel,
      .rc-calendar-month-panel,
      .rc-calendar-year-panel,
      .rc-calendar-decade-panel,
      .rc-calendar-time-picker,
      .rc-calendar-time-panel {
        background: var(--cp-surface, #161e23);
        color: var(--cp-text, #e6eaec);
      }
      .rc-calendar-date:hover {
        background: var(--cp-surface-hover, #232e35);
      }
    `}
`;

export const InputBox = styled.div`
  position: relative;
  i {
    position: absolute;
    top: 2px;
    right: 0px;
    //color: #fff;
    opacity: 0.6;
  }
`;
